import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import DOWN_SVG from "../../images/down.svg";

function BoardItem({isSecret, category, content, writer, registerAt, id, onComparePasswordHandler}){
    const navigate = useNavigate();
    const date = registerAt.toDate();
    
    const onItemClickHandler = () => {
        if(!isSecret){
            navigate("/inquiry/detail", {state:id})
        }else{
            onComparePasswordHandler(id);
        }
    }
    return(
        <Tr onClick={onItemClickHandler}>
            <Td style={{textAlign:"center"}} >{category}</Td>
            <Td >{content}</Td>
            <Td style={{textAlign:"center"}}>{writer === "anonymous" || "익명"}</Td>
            <Td style={{textAlign:"center"}}>{`${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`}</Td>
            <Td><ButtonShowDetail src={DOWN_SVG} alt="down_svg"/></Td>
        </Tr>
    )
}

const Tr = styled.tr`
    width: 100%;
    border-bottom: 1px solid #58AC65;
    &:hover{
        color:white;
        background-color: #58AC65;
    }
`


const Td = styled.td`
    padding-top: 20px;
    padding-bottom: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 500px;
    @media (max-width: 800px) {
        max-width: 300px;
    }
    @media (max-width: 600px) {
        max-width: 200px;
    }
    @media (max-width: 500px) {
        max-width: 100px;
    }
    
`

const ButtonShowDetail = styled.img`
    display: flex;
    width: 12px;
    align-items: center;
`

export default BoardItem;